import { render, staticRenderFns } from "./WelcomeWidget.vue?vue&type=template&id=77950c14&"
import script from "./WelcomeWidget.vue?vue&type=script&lang=js&"
export * from "./WelcomeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports